import useSWR, { SWRConfiguration } from 'swr';
import { createUseResource } from '~/api';
import { StockMovement } from '~/types';

const key = '/api/stock-movements?';

export const useStockMovements = (
  query?: string,
  options?: SWRConfiguration<StockMovement[]>
) => {
  const url = query ? key + query : key;
  return useSWR<StockMovement[]>(url, options);
};

export const useStockMovement = createUseResource(key);
